import { inferRouteObject } from 'react-router-typed-object';
import z from 'zod';

import { PrivateRoute, Roles, or } from '@/js/libs/use-auth';

import { forecastRouterSearchParamsSchema } from 'src/scenes/Orders/containers/Forecast/constants.ts';
import { programmaticDealsRouterSearchParamsSchema } from 'src/scenes/Orders/containers/ProgrammaticDeals/schema.ts';
import Orders from 'src/scenes/Orders/index.ts';
import Status from 'src/scenes/Status/index.ts';
import { PositionHistorySearchKey } from 'src/types.ts';

const index = true;

export const orders2RouteObject = inferRouteObject({
  path: 'orders',
  element: (
    <PrivateRoute
      roles={or(Roles.ADMIN, Roles.SELF_BOOKING, Roles.BOOK_CAMPAIGNS, Roles.POSTNETZ_BRANCH_USER, Roles.READ_ONLY_POSTNETZ_BRANCH_USER)}
      noAccessComponent={Status.NotFound}
    />
  ),
  children: [
    {
      Component: Orders.Helmet,
      children: [
        {
          element: <PrivateRoute roles={Roles.PROGRAMMATIC_DEALS} noAccessComponent={Status.NotFound} />,
          children: [
            {
              path: 'programmatic-deals',
              // The reporting page is the index child, so its search params stay on the route that
              // owns the path - moving them down would drop them from `ROUTER[...].path()`.
              searchParams: programmaticDealsRouterSearchParamsSchema.parse,
              children: [
                {
                  // The tabbed pages; the deal form below stays outside so it keeps its own PageHeader.
                  Component: Orders.ProgrammaticDeals.Layout,
                  children: [
                    { index, Component: Orders.ProgrammaticDeals.Report },
                    { path: 'deals', Component: Orders.ProgrammaticDeals.Deals },
                    { path: 'deliveries', Component: Orders.ProgrammaticDeals.Deliveries },
                    { path: 'size-sets', Component: Orders.ProgrammaticDeals.SizeSets },
                  ],
                },
                { path: 'deals/create', Component: Orders.ProgrammaticDeals.DealForm },
              ],
            },
          ],
        },
        {
          Component: Orders.PositionHistory.Providers,
          children: [
            {
              path: 'campaign/:campaignId/position-history/:positionId?',
              Component: Orders.PositionHistory.Component,
              searchParams: z.object({
                [PositionHistorySearchKey.BACK_TO]: z.string().optional(),
              }).parse,
            },
          ],
        },
        {
          element: <PrivateRoute roles={Roles.MANAGE_DIGITAL_PRODUCTS} noAccessComponent={Status.NotFound} />,
          children: [
            {
              path: 'forecast',
              Component: Orders.Forecast,
              searchParams: forecastRouterSearchParamsSchema.parse,
            },
          ],
        },
        {
          path: 'booking',
          Component: Orders.Booking,
        },
      ],
    },
  ],
});
